<template lang="pug">
.home.container.py-5
  .row.justify-content-center
    .col-12.col-md-10.col-lg-8.col-xl-7
      .card.border-0.shadow-sm.rounded-4.overflow-hidden
        .card-header.bg-light.border-0.p-3
          .nav.nav-pills.nav-fill.p-1.bg-white.rounded-3.shadow-sm
            li.nav-item
              a.nav-link.pointer.py-2(:class="{ active: isLogin }" @click="isLogin = true") 
                span.material-icons.me-2 login
                | {{ $t("message.login") }}
            li.nav-item
              a.nav-link.pointer.py-2(:class="{ active: !isLogin }" @click="isLogin = false")
                span.material-icons.me-2 person_add
                | {{ $t("message.register") }}
        
        .card-body.p-4.p-md-5
          transition(name="fade" mode="out-in")
            // Login Form
            div(v-if="isLogin" key="login")
              .text-center.mb-5
                h2.fw-bold.mb-2 {{ $t("message.login") }}
                p.text-muted {{ $t("message.welcomeBack") }}
              
              form#login(@submit.prevent="login")
                .form-floating.mb-3
                  input#EmailInput.form-control.rounded-3(type='email' v-model="username" :placeholder="$t('message.email')" @click="error = ''")
                  label(for="EmailInput") {{ $t("message.email") }}
                
                .form-floating.mb-4
                  input#PasswordInputLogin.form-control.rounded-3(type='password' v-model="password" :placeholder="$t('message.password')" @click="error = ''")
                  label(for="PasswordInputLogin") {{ $t("message.password") }}
                
                .d-flex.justify-content-between.align-items-center.mb-4
                  div.form-check
                    input#rememberMe.form-check-input(type="checkbox")
                    label.form-check-label.small(for="rememberMe") {{ $t("message.rememberMe") }}
                  button.btn.btn-link.btn-sm.text-decoration-none.p-0(type="button" @click='resetPassword') {{ $t("message.forgotPassword") }}
                
                p.error.text-danger.text-center.small.mb-3(v-if="error") {{error}}
                p.text-info.text-center.small.mb-3(v-if="tokenLoginLoading") {{ $t("message.checking") }}
                p.text-danger.text-center.small.mb-3(v-if="tokenLoginError") {{tokenLoginError}}
                
                .d-grid.gap-2
                  button.btn.btn-primary.btn-lg.rounded-3(type="submit") {{ $t("message.login") }}
                
                .mt-4.text-center
                  span.text-muted.small {{ $t("message.signInWith") }}
                  .d-grid.mt-2
                    button.btn.btn-outline-secondary.btn-sm.rounded-3(:disabled="!username.trim() || tokenLinkSending" @click='requestOneTimeLink')
                      span.material-icons.me-2.small mail
                      | {{ tokenLinkSending ? $t("message.checking") : $t("message.oneTimeLink") }}
            
            // Register Form
            div(v-else key="register")
              Register(@registered="isLogin = true")

</template>

<script>
import Register from "./../components/Register.vue";
import API from "./../API.js";
import { UserStore } from "../UserStore";

export default {
  name: 'Home',
  components: {
    Register
  },
  data(){
    return {
      isLogin: true,
      username: "",
      password: "",
      error: "",
      tokenLinkSending: false,
      tokenLoginLoading: false,
      tokenLoginError: "",
      handledToken: "",
      UserStore
    }
  },
  methods:{
    login(){
      if (!this.username || !this.password) {
        this.error = this.$t("message.fillAllFields");
        return;
      }
      API.logIn(this.username.toLowerCase(), this.password)
        .then((data) => {
          if(data && data.status && data.status === 'ok'){
            this.$router.push('Feed')
            this.UserStore.getMe();
          }else{
            this.error = data.status
          }
            
        });
    },
    resetPassword(){
      if(!this.username.trim()) {
        this.error = this.$t("message.enterEmailFirst");
        return;
      }
      API.resetPassword(this.username.toLowerCase()).then((data) => {
          if(data && data.status && data.status === 'ok'){
            this.error = data.details
          }else{
            this.error = data.status
          }
        });
    },
    requestOneTimeLink(){
      if(!this.username.trim()) return;
      this.tokenLinkSending = true;
      this.tokenLoginError = "";
      API.resetPassword(this.username.toLowerCase()).then((data) => {
        if(data && data.status === "ok"){
          this.error = data.details || "Check your email";
        } else {
          this.error = (data && data.status) || "Error";
        }
      }).finally(() => {
        this.tokenLinkSending = false;
      });
    },
    consumeTokenLoginFromRoute(){
      const token = this.$route && this.$route.query ? (this.$route.query.token || "") : "";
      const cleanToken = (token + "").trim();
      if(!cleanToken || cleanToken === this.handledToken) return;
      this.handledToken = cleanToken;
      this.tokenLoginLoading = true;
      this.tokenLoginError = "";
      API.logInWithPasswordToken(cleanToken).then((data) => {
        if(data && data.status === "ok"){
          this.UserStore.getMe();
          this.$router.push('Feed');
          return;
        }
        this.tokenLoginError = (data && data.status) || "Invalid token";
      }).finally(() => {
        this.tokenLoginLoading = false;
      });
    }
  },
  mounted(){
    this.consumeTokenLoginFromRoute();
    API.isLoggedIn().then((r)=>{
      if(r) this.$router.push('Feed')
    });
  },
  watch: {
    '$route.query.token'(){
      this.consumeTokenLoginFromRoute();
    }
  }
}
</script>

<style scoped lang="scss">
.home {
  max-width: 100% !important;
  margin: 0 auto;
}

.card {
  box-shadow: 0 0.5rem 1.5rem rgba(0, 0, 0, 0.08) !important;
}

.rounded-4 {
  border-radius: 1rem !important;
}

.rounded-3 {
  border-radius: 0.75rem !important;
}

.nav-pills {
  .nav-link {
    color: #6c757d;
    font-weight: 600;
    font-size: 0.95rem;
    transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
    border-radius: 0.5rem;
    display: flex;
    align-items: center;
    justify-content: center;
    
    &:hover:not(.active) {
      background-color: rgba(0,0,0,0.03);
    }
    
    &.active {
      background-color: #0d6efd;
      color: #fff;
      box-shadow: 0 4px 10px rgba(13, 110, 253, 0.2);
    }
  }
}

.form-control {
  background-color: #f8f9fa;
  border: 1px solid #dee2e6;
  padding: 0.75rem 1rem;
  
  &:focus {
    background-color: #fff;
    border-color: #0d6efd;
    box-shadow: 0 0 0 0.25rem rgba(13, 110, 253, 0.1);
  }
}

.form-floating > label {
  padding-left: 1rem;
}

.material-icons.small {
  font-size: 1.1rem;
}

.fade-enter-active, .fade-leave-active {
  transition: opacity 0.3s ease, transform 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}

.fade-enter-from, .fade-leave-to {
  opacity: 0;
  transform: translateY(8px);
}

.pointer {
  cursor: pointer;
}
</style>

